"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (_ref) {
  var Plugin = _ref.Plugin;
  var t = _ref.types;

  return new Plugin("remove-debugger", {
    metadata: {
      group: "builtin-pre"
    },

    visitor: {
      DebuggerStatement: function DebuggerStatement() {
        this.dangerouslyRemove();
      }
    }
  });
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/babel-plugin-remove-debugger/lib/index.js
// module id = 2207
// module chunks = 0